<ng-template [ngIf]="disabled">
    <input type="text" class="form-control" [value]="ngModel | clienteModoEnvioBoleto | uppercase" disabled="disabled" readonly="readonly">
</ng-template>

<ng-template [ngIf]="!disabled">
    <select 
        #select
        class="form-control" 
        [name]="name"
        [id]="id"
        [required]="required"
        [autofocus]="autofocus"
        [ngModel]="ngModel || ''" 
        (ngModelChange)="onChange($event ? $event : null)">
        <option value="" *ngIf="canSelectNull">NÃO INFORMADO</option>
        <option *ngFor="let modo of modos" [ngValue]="modo.id">{{modo.nome | uppercase}}</option>
    </select>  
</ng-template>